import React, { ButtonHTMLAttributes, MouseEventHandler, ReactElement } from 'react'

import classNames from 'classnames'

import { bemJoin } from '@app/lib/bem'
import './TileButton.scss'

export enum TileButtonVariant {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export enum TileButtonIconSize {
  Small = 'small',
  Normal = 'normal',
  Big = 'big',
  Unrestrained = 'unrestrained'
}

export enum TileButtonTextSize {
  Normal = 'normal',
  Big = 'big'
}

export enum TileButtonPaddingVariant {
  Spacious = 'spacious',
  Normal = 'normal',
  Compact = 'compact'
}

export interface TileButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  subText?: string
  variant: TileButtonVariant
  icon: ReactElement
  iconSize?: TileButtonIconSize
  selected?: boolean
  disabled?: boolean
  onClick?: MouseEventHandler
  className?: string
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type']
  testId?: string
  textSize?: TileButtonTextSize
  paddingVariant?: TileButtonPaddingVariant
}

export const TileButton = ({
  text,
  subText,
  variant,
  icon,
  iconSize = TileButtonIconSize.Normal,
  selected,
  disabled,
  onClick,
  className,
  type,
  testId,
  paddingVariant,
  textSize = TileButtonTextSize.Normal,
  ...htmlButtonProps
}: TileButtonProps) => {
  const b = bemJoin('tile-button')
  const modifiers = {
    selected: Boolean(selected),
    disabled: Boolean(disabled),
    [variant]: true,
    [`icon-${iconSize}`]: true,
    [paddingVariant || TileButtonPaddingVariant.Compact]: true,
    [`text-${textSize}`]: true
  }

  return (
    <button
      {...htmlButtonProps}
      type={type ?? 'button'}
      data-testid={testId}
      className={`${classNames(b('container', modifiers))}${className ? ` ${className}` : ''}`}
      onClick={disabled ? undefined : onClick}
    >
      <div className={b('icon', modifiers)}>{icon}</div>
      <div className={b('content')}>
        <div className={b('text', modifiers)}>{text}</div>
        {!!subText ? <div className={b('sub-text', modifiers)}>{subText}</div> : undefined}
      </div>
    </button>
  )
}
